/**
 * Created by umbert on 01/06/2016.
 */
var SearchModule = (function () {

    // declare private variables and/or functions
    var object_cutGradeCheckboxEX = $("#cutGradeCheckboxEX");
    var object_cutGradeCheckboxVG = $("#cutGradeCheckboxVG");
    var object_polishCheckboxEX = $("#polishCheckboxEX");
    var object_polishCheckboxVG = $("#polishCheckboxVG");
    var object_symmetryCheckboxEX = $("#symmetryCheckboxEX");
    var object_symmetryCheckboxVG = $("#symmetryCheckboxVG");
    var object_fluorescenceIntensityCheckboxN = $("#fluorescenceIntensityCheckboxN");
    var object_fluorescenceIntensityCheckboxVSL = $("#fluorescenceIntensityCheckboxVSL");
    var object_fluorescenceIntensityCheckboxFSL = $("#fluorescenceIntensityCheckboxFSL");
    var object_price_selector = $("#price_selector");

    var object_weight_selector = $("#weight_selector");
    var object_min_weight = $("input[name=min_weight]");
    var object_max_weight = $("input[name=max_weight]");
    var object_min_price = $("input[name=min_price]");
    var object_max_price = $("input[name=max_price]");
    var object_min_depth_percentage = $("input[name=min_depth_percentage]");
    var object_max_depth_percentage = $("input[name=max_depth_percentage]");
    var object_min_table_percentage = $("input[name=min_table_percentage]");
    var object_max_table_percentage = $("input[name=max_table_percentage]");
    var object_min_length = $("input[name=min_length]");
    var object_max_length = $("input[name=max_length]");
    var object_min_width = $("input[name=min_width]");
    var object_max_width = $("input[name=max_width]");
    var object_min_depth = $("input[name=min_depth]");
    var object_max_depth = $("input[name=max_depth]");
    var object_min_ratio = $("input[name=min_ratio]");
    var object_max_ratio = $("input[name=max_ratio]");
    var object_girdle_thin = $("#girdle_thin");
    var object_girdle_thick = $("#girdle_thick");

    var shapeCheckbox = getCheckboxesValues("shapeCheckbox[]");
    var colorCheckbox = getCheckboxesValues("colorCheckbox[]");
    var clarityCheckbox = getCheckboxesValues("clarityCheckbox[]");
    var cutGradeCheckbox = getCheckboxesValues("cutGradeCheckbox[]");
    var girdleConditionCheckbox = getCheckboxesValues("girdleConditionCheckbox[]");
    var polishCheckbox = getCheckboxesValues("polishCheckbox[]");
    var symmetryCheckbox = getCheckboxesValues("symmetryCheckbox[]");
    var fluorescenceIntensityCheckbox = getCheckboxesValues("fluorescenceIntensityCheckbox[]");
    var laboratoryCheckbox = getCheckboxesValues("laboratoryCheckbox[]");

    var checkboxes_array_names = [
        "colorCheckbox[]",
        "clarityCheckbox[]",
        "shapeCheckbox[]",
        "cutGradeCheckbox[]",
        "girdleConditionCheckbox[]",
        "polishCheckbox[]",
        "symmetryCheckbox[]",
        "fluorescenceIntensityCheckbox[]",
        "laboratoryCheckbox[]"
    ];

    /**
     * Deletes the search criteria cookie
     */
    function deleteSearchCriteriaCookie() {
        Cookies.remove('searchCriteria');
    }

    function refreshCheckboxVariableValues() {
        shapeCheckbox = getCheckboxesValues("shapeCheckbox[]");
        colorCheckbox = getCheckboxesValues("colorCheckbox[]");
        clarityCheckbox = getCheckboxesValues("clarityCheckbox[]");
        cutGradeCheckbox = getCheckboxesValues("cutGradeCheckbox[]");
        girdleConditionCheckbox = getCheckboxesValues("girdleConditionCheckbox[]");
        polishCheckbox = getCheckboxesValues("polishCheckbox[]");
        symmetryCheckbox = getCheckboxesValues("symmetryCheckbox[]");
        fluorescenceIntensityCheckbox = getCheckboxesValues("fluorescenceIntensityCheckbox[]");
        laboratoryCheckbox = getCheckboxesValues("laboratoryCheckbox[]");
    }

    function resetPredefinedFilterCheckbox() {
        $('input[id^="predefinedFilter_"]').each(function () {
            $(this).prop("checked", false);
        });
    }

    function resetFilterDropdown() {
        $('#user_filter_select').val('---');
    }

    /**
     * Resets the weight filters to the predefined values
     */
    function resetWeightFilterElements() {
        object_weight_selector.val("na");
        object_min_weight.val('0.18');
        object_max_weight.val('5');
    }

    /**
     * Sends an ajax call to save the current search criteria in the DB
     */
    function saveSearchCriteria() {
        refreshCheckboxVariableValues();
        $.ajax({
            url: laroute.route('filter.store'),
            method: 'POST',
            data: {
                filter_name: $("#filter-name").val(),
                min_weight: object_min_weight.val(),
                max_weight: object_max_weight.val(),
                min_price: object_min_price.val(),
                max_price: object_max_price.val(),
                min_depth_percentage: object_min_depth_percentage.val(),
                max_depth_percentage: object_max_depth_percentage.val(),
                min_table_percentage: object_min_table_percentage.val(),
                max_table_percentage: object_max_table_percentage.val(),
                min_length: object_min_length.val(),
                max_length: object_max_length.val(),
                min_width: object_min_width.val(),
                max_width: object_max_width.val(),
                min_depth: object_min_depth.val(),
                max_depth: object_max_depth.val(),
                shapeCheckbox: shapeCheckbox,
                colorCheckbox: colorCheckbox,
                clarityCheckbox: clarityCheckbox,
                cutGradeCheckbox: cutGradeCheckbox,
                girdle_thin: object_girdle_thin.val(),
                girdle_thick: object_girdle_thick.val(),
                girdleConditionCheckbox: girdleConditionCheckbox,
                polishCheckbox: polishCheckbox,
                symmetryCheckbox: symmetryCheckbox,
                fluorescenceIntensityCheckbox: fluorescenceIntensityCheckbox,
                laboratoryCheckbox: laboratoryCheckbox,
                price_selector: object_price_selector.val()
            }
        }).done(function () {
            resetPredefinedFilterCheckbox();
            resetFilterDropdown();
            var filter_name = $("#filter-name");
            new PNotify({
                text: 'Filter saved: ' + filter_name.val(),
                type: 'success'
            });
            filter_name.val('');
        });
    }

    /**
     * Shows a message for an invalid filter name
     */
    function invalidFilterName() {
        new PNotify({
            text: 'Invalid filter name',
            type: 'error'
        });
    }

    /**
     * Shows a message for an invalid filter name
     */
    function filterLoadedNotify() {
        new PNotify({
            text: 'Filter loaded',
            type: 'success'
        });
    }

    /**
     * Returns an array with the values of the ticked checkboxes
     *
     * @param name
     * @returns {Array}
     */
    function getCheckboxesValues(name) {
        var allVals = [];
        $("input[name='" + name + "']:checked").each(function () {
            allVals.push($(this).val());
        });
        return allVals;
    }

    /**
     * Ticks the desired checkbox
     * @param name
     * @param values
     */
    function setCheckboxesValues(name, values) {
        if (typeof(values) !== "undefined" && values !== null) {
            $("input[name='" + name + "']").each(function () {
                var found = $.inArray($(this).val(), values) > -1;
                if (found) {
                    $(this).prop("checked", true);
                }
            });
        }
    }

    /**
     * Reset all the defined checkboxes in the search area.
     */
    function resetAllCheckboxes(checkbox_groups) {
        groups_to_be_reset = checkboxes_array_names;
        if (typeof(checkbox_groups) !== "undefined" && checkbox_groups !== null) {
            groups_to_be_reset = checkbox_groups;
        }
        $(groups_to_be_reset).each(function (key, name) {
            $("input[name='" + name + "']").each(function () {
                $(this).prop("checked", false);
            });
        });
    }

    function addDiamondGridRows(data) {
        var rows = Math.floor(data.length / 3) ;
        var extras = data.length % 3 ;
        var allRows = "" ;

        //handle full rows
        for (var i = 0; i < rows; i++) {
            row = "<div class=\"row diamond-grid-row\">\n" +
                "            <div id=\"diamond-grid-square-template\" onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[i*3])+");\" diamond-id=\""+getDiamondId(data[i*3])+"\" class=\"col-sm-4 diamond-grid-box "+ data[i*3].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[(i*3)])+"\n" +
                "            </div>\n" +
                "            <div onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[(i*3)+1])+");\" class=\"col-sm-4 diamond-grid-box "+ data[(i*3)+1].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[(i*3)+1])+"\n" +
                "            </div>\n" +
                "            <div onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[(i*3)+2])+");\" class=\"col-sm-4 diamond-grid-box "+ data[(i*3)+2].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[(i*3)+2])+"\n" +
                "            </div>\n" +
                "        </div>" ;
            allRows = allRows + row ;
        }

        //handle extras
        if (extras == 1) {
            row = "<div class=\"row diamond-grid-row\">\n" +
                "            <div onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[data.length-1])+");\" id=\"diamond-grid-square-template\" class=\"col-sm-4 diamond-grid-box "+ data[data.length-1].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[data.length-1])+"\n" +
                "            </div>\n" +
                "        </div>" ;
            allRows = allRows + row ;
        } else if (extras == 2) {
            row = "<div class=\"row diamond-grid-row\">\n" +
                "            <div onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[data.length-2])+");\" id=\"diamond-grid-square-template\" class=\"col-sm-4 diamond-grid-box "+ data[data.length-2].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[data.length-2])+"\n" +
                "            </div>\n" +
                "            <div onclick=\"SearchModule.gridCBToggle("+getDiamondId(data[data.length-1])+");\" class=\"col-sm-4 "+ data[data.length-1].DT_RowClass+"\">\n" +
                "                "+populateDiamondTemplate(data[data.length-1])+"\n" +
                "            </div>\n" +
                "        </div>" ;
            allRows = allRows + row ;
        }

        $('#diamonds-grid-container')[0].innerHTML = '' ;
        $('#diamonds-grid-container').append(allRows) ;

    }

    function getDiamondId(data) {
        var diamondId = data.vendor_stock_number.substring(data.vendor_stock_number.search(">")+1) ;
        diamondId = diamondId.substring(0,diamondId.search("<")) ;
        return diamondId ;
    }

    function populateDiamondTemplate(data) {
        //id processing
        var diamondId = data.vendor_stock_number.substring(data.vendor_stock_number.search(">")+1) ;
        diamondId = diamondId.substring(0,diamondId.search("<")) ;
        //status processing
        var statusTag = "" ;
        var style = "" ;
        if (data.DT_RowClass == "stone-available") {
            //statusTag = "<span class=\"glyphicon glyphicon-record\" style=\"color: green;\"></span> Available ;
            statusTag = "<a href=\"#\" onclick=\"addDiamondToCart("+diamondId+", true, false);return false;\"><span class=\"glyphicon glyphicon-shopping-cart\" style=\"color:white\"></span></a>" ;
        } else {
            statusTag = "<span class=\"glyphicon glyphicon-remove-circle\" style=\"color: darkred;\"> </span><span style='color: darkred;'/> " ;
            style = 'style="display: none ;"' ;
        }

        /*if (data.video_url != null) {
            var vlink = data.video_url ;
            data.video_url = '<a href="'+vlink+'">360 Video</a>' ;
        }*/

        var replacements = new Array("$$diamondid","$$shape","$$price","$$color","$$polish","$$rap","$$clarity","$$symmetry","$$weight","$$cut","$$fluorescence","$$lablink","$$360link","$$status", "$$style","$$measures", "$$pc_price", "$$grid_class") ;
        var diamondData = new Array(diamondId,data.shape,data.price_total,data.color,data.polish,data.rap_list_percentage,data.clarity,data.symmetry,data.weight,data.cut_grade,data.fluorescence_intensity,data.certificate,data.video_url,statusTag, style, data.measures, data.price_pc, data.DT_RowClass) ;
        var template = loadDiamondGridTemplate() ;
        for (var i = 0; i < replacements.length; i++) {
            if (i == 0) {
                //TODO:: temp code, use regex for efficiency
                //var rex = new RegExp(replacements[i], "g") ;
                //template = template.replace(rex,diamondData[i]) ;
                template = template.replace(replacements[i],diamondData[i]) ;
                template = template.replace(replacements[i],diamondData[i]) ;
                template = template.replace(replacements[i],diamondData[i]) ;
                template = template.replace(replacements[i],diamondData[i]) ;
            } else {
                if (diamondData[i] == null) {
                    diamondData[i] = "" ;
                }
                template = template.replace(replacements[i],diamondData[i]) ;
            }

        }
        return template ;
    }

    function loadDiamondGridTemplate() {
        var template = $('#diamond-grid-square-template .diamond-grid-square')[0].innerHTML ;
        return template ;
    }

    function resetAdvancedFilterElements() {

        object_min_depth_percentage.val('');
        object_max_depth_percentage.val('');

        object_min_table_percentage.val('');
        object_max_table_percentage.val('');

        object_min_length.val('');
        object_max_length.val('');

        object_min_width.val('');
        object_max_width.val('');

        object_min_depth.val('');
        object_max_depth.val('');

        object_min_ratio.val('');
        object_max_ratio.val('');

        object_girdle_thin.val('');
        object_girdle_thick.val('');

        resetAllCheckboxes(["girdleConditionCheckbox[]"]);
    }

    function resetPriceFilterElements() {
        object_min_price.val('');
        object_max_price.val('');
        object_price_selector.val('price_pc');
    }

    return {
        // declare public variables and/or functions

        initializeDiamondsTable: function () {

            //window size handling
            width = $(window).width() ;
            if (width < 800) {
                $('#diamonds-table_wrapper').hide() ;
                $('#diamonds-loading-div').show() ;
                $('#diamonds-grid').fadeIn() ;
                $('#gridBtn').addClass('active') ;
                $('#listBtn').removeClass('active') ;
            }

            if (!$.fn.DataTable.isDataTable('#diamonds-table')) {
                var table = $('#diamonds-table').DataTable({
                    dom: "<'colvis-button pull-sm-left u-pad-bottom-'>Bfrtip<'export-buttons'>",
                    language: {
                        searchPlaceholder: "Search in results..."
                    },
                    processing: true,
                    serverSide: true,
                    deferRender: true,
                    scrollX: true,
                    scrollY: "500px",
                    stateSave: true,
                    buttons: ['colvis'],
                    buttons: [
                        { extend: 'colvis', text: 'Display options <span class="glyphicon glyphicon-triangle-bottom u-pad-left-"></span>' },
                        {
                            text: 'Add Selected to Comparison',
                            className: 'table-button-disabled',
                            name: 'add-compare-btn',
                            action: function ( e, dt, node, config ) {
                                SearchModule.sendShortlist() ;
                            }
                        },
                        {
                            text: 'View Comparison',
                            //className: 'table-button-disabled',
                            name: 'view-compare-btn',
                            action: function (e,dt,node,config) {
                                window.location = ('/compare') ;
                            }
                        }
                    ],
                    scrollCollapse: true,
                    paginate: false,
                    pagingType: "scrolling",
                    fixedHeader: false,
                    fixedColumns: true,
                    colReorder: false,
                    order: [[1, 'desc']],
                    aoColumnDefs: [
                        {"bVisible": false, "aTargets": [14]},
                        {"orderable": false, "targets": 0 }
                    ],
                    drawCallback: function(settings) {
                        $('[title]').tooltip({ placement : 'bottom'}) ;
                        var api = this.api();
                        var gridData = api.rows( {page:'current'} ).data() ;
                        addDiamondGridRows(gridData) ;
                        $('#diamonds-table_filter input').attr('placeholder', 'Search in results...');
                        $('#diamonds-loading-div').hide() ;
                        if ($('#gridBtn').hasClass('active')) {
                            $('#diamonds-grid').fadeIn() ;
                        } else {
                            $('#diamonds-table-complete').fadeIn() ;
                        }
                    },
                    ajax: {
                        url: laroute.route('datatables.data'),
                        data: function (d) {
                            d.shape = shapeCheckbox;
                            d.min_weight = object_min_weight.val();
                            d.max_weight = object_max_weight.val();
                            d.min_price = object_min_price.val();
                            d.max_price = object_max_price.val();
                            d.min_depth_percentage = object_min_depth_percentage.val();
                            d.max_depth_percentage = object_max_depth_percentage.val();
                            d.min_table_percentage = object_min_table_percentage.val();
                            d.max_table_percentage = object_max_table_percentage.val();
                            d.min_length = object_min_length.val();
                            d.max_length = object_max_length.val();
                            d.min_width = object_min_width.val();
                            d.max_width = object_max_width.val();
                            d.min_depth = object_min_depth.val();
                            d.max_depth = object_max_depth.val();
                            d.min_ratio = object_min_ratio.val();
                            d.max_ratio = object_max_ratio.val();
                            d.color = colorCheckbox;
                            d.clarity = clarityCheckbox;
                            d.cut_grade = cutGradeCheckbox;
                            d.girdle_thin = object_girdle_thin.val();
                            d.girdle_thick = object_girdle_thick.val();
                            d.girdle_condition = girdleConditionCheckbox;
                            d.polish = polishCheckbox;
                            d.symmetry = symmetryCheckbox;
                            d.fluorescence_intensity = fluorescenceIntensityCheckbox;
                            d.laboratory = laboratoryCheckbox;
                            d.price_selector = object_price_selector.val();
                            d.memo_inc = $('#memoChk').is(':checked') ;
                            d.lg_toggle = $('#lgToggle').is(':checked') ;
                        },
                        failure:function(result){console.log(result.sEcho);}
                    },
                    columns: [
                        {data: 'select', name: 'select', searchable: false, fixed: true},
                        {data: 'vendor_stock_number', name: 'vendor_stock_number'},
                        {data: 'video_url', name: 'video_url', orderable: false, searchable: false},
                        {data: 'shape', name: 'shape'},
                        {data: 'weight', name: 'weight', visible: true},
                        {data: 'color', name: 'color'},
                        {data: 'clarity', name: 'clarity'},
                        {data: 'cut_grade', name: 'cut_grade'},
                        {data: 'polish', name: 'polish'},
                        {data: 'symmetry', name: 'symmetry'},
                        {data: 'fluorescence_intensity', name: 'fluorescence_intensity'},
                        {data: 'certificate', name: 'certificate', orderable: false, searchable: false},
                        {data: 'measures', name: 'measures', orderable: false, searchable: false, visible: false},
                        {data: 'rap_list_percentage', name: 'rap_list_percentage'},
                        {data: 'table_percentage', name: 'table_percentage', visible: false},
                        {data: 'price_pc', name: 'price_pc', type: 'num-fmt', searchable: false, visible: false},
                        {data: 'price_total', name: 'price_total', type: 'num-fmt'},
                        {data: 'price_change', name: 'price_change', searchable: false, visible: false},
                        {data: 'status', name: 'status', visible: false},
                        {data: 'addToCart', name: 'addToCart', orderable: false, searchable: false}
                    ],
                    oLanguage: {
                        "sSearch": "",
                        "sSearchPlaceholder": "Search...",
                        "sProcessing": "<img class='dtLoading' src='/img/loading.svg'/>"
                    }
                });

                new $.fn.dataTable.Buttons( table, {
                    buttons: ['csvHtml5', 'excelHtml5', 'copyHtml5'],
                } );

                $("div.export-buttons").addClass('pull-sm-right text-sm-right u-pad-x-').html('<div class="u-pad-bottom-"><button type="button" class="Button Button--keyline" data-toggle="collapse" data-target="#datatables-buttons">Download inventory<span class="u-pad-left- glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span></button></div><div id="datatables-buttons" class="collapse"></div>');

                table.buttons().container().appendTo($(".colvis-button"));

                table.buttons( 1, null ).container().appendTo($("#datatables-buttons"));
            }

        },

        /**
         * Toggles the panel with search fields and the datatable.
         */
        toggleSearchPage: function () {
            $('#search-filters').collapse("toggle");
            $('#diamonds-table-collapsible').collapse("show");
        },

        toggleCB: function (item) {
          $(item).parent().toggleClass('cb-selected') ;
        },

        gridCBToggle: function (id) {
            //console.log(id);
            if ($("input[value='" + id + "']").css('display') != 'none') {
                $("input[value='" + id + "']").click();
            }
        },

        /**
         * Save the current search criteria in a cookie
         */
        saveSearchCriteriaCookie: function () {
            refreshCheckboxVariableValues();
            Cookies.set('searchCriteria', {
                "shapeCheckbox": shapeCheckbox,
                "min_weight": object_min_weight.val(),
                "max_weight": object_max_weight.val(),
                "min_price": object_min_price.val(),
                "max_price": object_max_price.val(),
                "colorCheckbox": colorCheckbox,
                "clarityCheckbox": clarityCheckbox,
                "cutGradeCheckbox": cutGradeCheckbox,
                "girdle_thin": object_girdle_thin.val(),
                "girdle_thick": object_girdle_thick.val(),
                "girdleConditionCheckbox": girdleConditionCheckbox,
                "polishCheckbox": polishCheckbox,
                "symmetryCheckbox": symmetryCheckbox,
                "fluorescenceIntensityCheckbox": fluorescenceIntensityCheckbox,
                "laboratoryCheckbox": laboratoryCheckbox,
                "price_selector": object_price_selector.val()
            });
        },

        /**
         * Returns the saved search criteria cookie
         * @returns json
         */
        getSearchCriteriaCookie: function () {
            return Cookies.getJSON('searchCriteria');
        },

        /**
         * Loads all the filters values from an associative array.
         *
         * @param info
         */
        loadSearchFilter: function (info) {
            object_min_weight.val(info.min_weight);
            object_max_weight.val(info.max_weight);
            object_min_price.val(info.min_price);
            object_max_price.val(info.max_price);
            object_min_depth_percentage.val(info.min_depth_percentage);
            object_max_depth_percentage.val(info.max_depth_percentage);
            object_min_table_percentage.val(info.min_table_percentage);
            object_max_table_percentage.val(info.max_table_percentage);
            object_min_length.val(info.min_length);
            object_max_length.val(info.max_length);
            object_min_width.val(info.min_width);
            object_max_width.val(info.max_width);
            object_min_depth.val(info.min_depth);
            object_max_depth.val(info.max_depth);
            object_min_ratio.val(info.min_ratio);
            object_max_ratio.val(info.max_ratio);
            object_girdle_thin.val(info.girdle_thin);
            object_girdle_thick.val(info.girdle_thick);
            object_price_selector.val(info.price_selector);
            setCheckboxesValues("colorCheckbox[]", info.colorCheckbox);
            setCheckboxesValues("clarityCheckbox[]", info.clarityCheckbox);
            setCheckboxesValues("shapeCheckbox[]", info.shapeCheckbox);
            setCheckboxesValues("cutGradeCheckbox[]", info.cutGradeCheckbox);
            setCheckboxesValues("girdleConditionCheckbox[]", info.girdleConditionCheckbox);
            setCheckboxesValues("polishCheckbox[]", info.polishCheckbox);
            setCheckboxesValues("symmetryCheckbox[]", info.symmetryCheckbox);
            setCheckboxesValues("fluorescenceIntensityCheckbox[]", info.fluorescenceIntensityCheckbox);
            setCheckboxesValues("laboratoryCheckbox[]", info.laboratoryCheckbox);
        },

        /**
         * Set's the text box for weight depending on the weight dropdown selector.
         *
         * @param select_option
         */
        setWeightsFromSelect: function (select_option) {
            switch (select_option) {
                case "na":
                    object_min_weight.val('');
                    object_max_weight.val('');
                    break;
                case "0.18":
                    object_min_weight.val(0.18);
                    object_max_weight.val(0.22);
                    break;
                case "0.23":
                    object_min_weight.val(0.23);
                    object_max_weight.val(0.29);
                    break;
                case "0.30":
                    object_min_weight.val(0.30);
                    object_max_weight.val(0.39);
                    break;
                case "0.40":
                    object_min_weight.val(0.40);
                    object_max_weight.val(0.49);
                    break;
                case "0.50":
                    object_min_weight.val(0.50);
                    object_max_weight.val(0.59);
                    break;
                case "0.60":
                    object_min_weight.val(0.60);
                    object_max_weight.val(0.69);
                    break;
                case "0.70":
                    object_min_weight.val(0.70);
                    object_max_weight.val(0.79);
                    break;
                case "0.80":
                    object_min_weight.val(0.80);
                    object_max_weight.val(0.89);
                    break;
                case "0.90":
                    object_min_weight.val(0.90);
                    object_max_weight.val(0.99);
                    break;
                case "1.00":
                    object_min_weight.val(1.00);
                    object_max_weight.val(1.19);
                    break;
                case "1.20":
                    object_min_weight.val(1.20);
                    object_max_weight.val(1.49);
                    break;
                case "1.50":
                    object_min_weight.val(1.50);
                    object_max_weight.val(1.99);
                    break;
                case "2.00":
                    object_min_weight.val(2.00);
                    object_max_weight.val(2.99);
                    break;
                case "3.00":
                    object_min_weight.val(3.00);
                    object_max_weight.val(3.99);
                    break;
                case "4.00":
                    object_min_weight.val(4.00);
                    object_max_weight.val(4.99);
                    break;
                case "5.00":
                    object_min_weight.val(5.00);
                    object_max_weight.val('');
                    break;
            }
        },

        /**
         * Set's the filter values for a predefined filters.
         * @param filter_name
         */
        setSearchFilters: function (filter_name) {

            SearchModule.resetPredefinedFiltersElements();

            switch (filter_name) {
                case "3_EX_N":
                    object_cutGradeCheckboxEX.prop('checked', true);
                    object_polishCheckboxEX.prop('checked', true);
                    object_symmetryCheckboxEX.prop('checked', true);
                    object_fluorescenceIntensityCheckboxN.prop('checked', true);
                    break;

                case "3_VG_F_+":
                    object_cutGradeCheckboxEX.prop('checked', true);
                    object_cutGradeCheckboxVG.prop('checked', true);
                    object_polishCheckboxEX.prop('checked', true);
                    object_polishCheckboxVG.prop('checked', true);
                    object_symmetryCheckboxEX.prop('checked', true);
                    object_symmetryCheckboxVG.prop('checked', true);
                    object_fluorescenceIntensityCheckboxN.prop('checked', true);
                    object_fluorescenceIntensityCheckboxVSL.prop('checked', true);
                    object_fluorescenceIntensityCheckboxFSL.prop('checked', true);
                    break;
            }
            SearchModule.setCBClass() ;
            $('#diamonds-filters').trigger("change");
        },

        setCBClass: function () {
            $('input:checkbox:checked').not('.sr-only').not('#memoChk').each(function() {
                    $(this).parent().addClass('cb-selected') ;
            });
            $('input:checkbox:not(:checked)').not('.sr-only').each(function() {
                $(this).parent().removeClass('cb-selected') ;
            });
        },

        /**
         * Apply a saved filter.
         *
         * @param filter_id
         * @param name
         */
        applyDropdownFilter: function (filter_id, name) {
            SearchModule.resetFilters();
            SearchModule.getFilter(filter_id);
        },

        /**
         * Makes an Ajax call to make sure that the filter name is not in use already.
         */
        checkFilterName: function () {

            //check for blank name
            var fn = $("#filter-name").val() ;
            if (fn == '') {
                $("#filter-name").addClass('form-error') ;
                return ;
            } else {
                $("#filter-name").removeClass('form-error') ;

                //continue with submit
                $.ajax({
                    url: laroute.route('filter.nameCheck'),
                    method: 'POST',
                    data: {
                        filter_name: $("#filter-name").val()
                    }
                }).done(function (result) {
                    $('#saveSearchModal').modal('hide');
                    if (result.success) {
                        saveSearchCriteria();
                    } else {
                        invalidFilterName();
                    }
                });

            }
        },


        /**
         * Makes and ajax call to retrieve a filters information form the DB
         * @param var_filter_id
         */
        getFilter: function (var_filter_id) {
            $.ajax({
                url: "/filter/" + var_filter_id,
                method: 'get'
            }).done(function (response) {
                SearchModule.loadSearchFilter(response.filter);
                filterLoadedNotify();
            });
        },

        /**
         * Resets all the fields which are related to predefined filters
         */
        resetPredefinedFiltersElements: function () {

            deleteSearchCriteriaCookie();

            chekbox_groups = [
                "cutGradeCheckbox[]",
                "polishCheckbox[]",
                "symmetryCheckbox[]",
                "fluorescenceIntensityCheckbox[]",
                "laboratoryCheckbox[]"
            ];
            resetAllCheckboxes(chekbox_groups);

            resetAdvancedFilterElements();
            resetPriceFilterElements();
        },

        /**
         * Resets all the fields to it default value.
         */
        resetFilters: function (withExtra) {

            resetAllCheckboxes();
            resetWeightFilterElements();
            resetPriceFilterElements();
            resetAdvancedFilterElements();

            deleteSearchCriteriaCookie();

            if (withExtra && withExtra !== undefined) {
                resetPredefinedFilterCheckbox();
                resetFilterDropdown();
            }

            //Deselect all selected filter options
            $('.cb-selected').removeClass('cb-selected') ;

            //reset popular filter selection
            $('.c-Filters-preselect-section input:radio').prop('checked', false);

        },

        /**
         * returns true if the search button is expecting to trigger the search. not expanding filters
         */
        weAreSearching: function () {
            return $("#search-filters").hasClass('in');
        },

        /**
         * Functions below added to support the compare function
         */

        getChecked: function () {
            var checkedValues = $('.diamond-select:checked').map(function() {
                return this.value;
            }).get();
            return checkedValues ;
        },

        checkGridSelected: function () {
            var checked = SearchModule.getChecked() ;
            if (checked.length > 0) {
                $('.sl-status2').remove() ;
                $('.footerButtonTxt').show() ;
                $('.footerOverlay').fadeIn() ;
            } else {
                $('.footerOverlay').fadeOut() ;
            }
        },

        checkSelected: function () {
            var checked = SearchModule.getChecked() ;
            if (checked.length > 0) {
                $('.buttons-colvis').next().removeClass('table-button-disabled') ;
            } else {
                $('.buttons-colvis').next().addClass('table-button-disabled') ;
            }
        },

        clickViewToggle: function(view) {
            if (view) {
                $('#diamonds-table_wrapper').hide() ;
                $('#diamonds-grid').fadeIn() ;
                $('#gridBtn').addClass('active') ;
                $('#listBtn').removeClass('active') ;
            } else {
                $('#diamonds-grid').hide() ;
                $('#diamonds-table-complete').fadeIn() ;
                $('#diamonds-table_wrapper').fadeIn() ;
                $('#listBtn').addClass('active') ;
                $('#gridBtn').removeClass('active') ;
            }
        },

        updateShortlist: function () {
            var checked = SearchModule.getChecked() ;
            var current = Cookies.getJSON('c-list') ;
            var newlist = checked.concat(current) ;

            var ulist = [] ;

            $.each(newlist, function(i, el){
                if($.inArray(el, ulist) === -1 && (el != '[]') && (el != '')) ulist.push(el);
            });

            Cookies.set('c-list',ulist) ;
        },

        sendShortlist: function() {
            if (!$('.btn-group a').hasClass('table-button-disabled')) {


                $('.sl-status').remove();
                $('.btn-group').after("<span class='sl-status'><img src='img/loading.svg'/></span>");

                $('.sl-status2').remove();
                $('.footerButtonTxt').after("<span style='margin-top: 12px;' class='sl-status2'><img height='20px' style='margin-top: 12px;' src='img/dotloader.svg'/></span>");
                $('.footerButtonTxt').hide();

                $.ajaxSetup({
                    header: $('meta[name="_token"]').attr('content')
                });

                var user_id = $('#user_id').attr('data-id') ;
                var sendData = SearchModule.getChecked();
                var dJS = JSON.stringify(sendData);

                $.ajax({

                    type: 'POST',
                    url: '/compare/save',
                    data: {list: dJS, user_id: user_id},
                    dataType: 'json',
                    success: function (data) {
                        $('.sl-status').remove();
                        $('.btn-group').after("<span style='color: #0093C3' class='sl-status glyphicon glyphicon-ok u-pad-left-'></span>");
                        $('.sl-status').delay(3000).fadeOut();

                        $('.sl-status2').html("<span style='margin-top: 12px;' style='color: white' class='sl-status2 glyphicon glyphicon-ok u-pad-left-'></span>");
                        //$('.footerOverlay').delay(3000).fadeOut();

                        return 1;
                    },
                    error: function (data) {
                        $('.sl-status').remove();
                        $('.btn-group').after("<span style='color:red' class='sl-status glyphicon glyphicon-exclamation-sign u-pad-left-'></span>");
                        $('.sl-status').delay(3000).fadeOut();

                        $('.sl-status2').html("<span style='margin-top: 12px;' style='color:red' class='sl-status2 glyphicon glyphicon-exclamation-sign u-pad-left-'></span>");
                        //$('.footerOverlay').delay(3000).fadeOut();
                    }
                });

            }
        },

        checkToggle: function() {
            if ($.fn.DataTable.isDataTable('#diamonds-table')) {
                $('#diamonds-table').DataTable().draw();
            }
    }

    }

})();
